var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.currentField.label,"label-width":_vm.currentField.labelWidth + 'px'}},[_c('el-time-select',{attrs:{"picker-options":{
        start: '00:00',
        step: '00:15',
        end: '23:45'
      },"placeholder":"Select time"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }